import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';

import CornerArrow from '../../icons/CornerArrow.svg';
import { AnimatedIconButton } from '../AnimatedIconButton/AnimatedIconButton';
import { useStudioSignupUrl } from '../../hooks/useStudioSignupUrl';
import cs from 'classnames';

import s from './SignupButton.scss';

type Type = {
  dataHook?: string;
  onClick?: () => void;
  className?: string;
};

export const SignupButton: FC<Type> = (props) => {
  const { t } = useTranslation();
  const studioSignupUrl = useStudioSignupUrl();

  return (
    <AnimatedIconButton
      dataHook={props.dataHook}
      size="large"
      skin="dark"
      className={cs(s.button, props.className)}
      as="a"
      href={studioSignupUrl}
      animatedIcon={<CornerArrow fill="#ffffff" />}
      onClick={props.onClick}
    >
      {t('app.new.subheader.button.outbound')}
    </AnimatedIconButton>
  );
};
